import React from "react";
import { Flex, LoadingIndicator, Text } from "@jsq/ds/core";
import { Colors } from "@jsq/ds/styles";
import { useGetLinkedIssueKeysQuery } from "#graphql/supergraphHooks";
import { SPACING } from "#utils/spacing";
import { LinkedIssueCard } from "./LinkedIssueCard";
import * as styles from "./styles_vanilla.css";
import { ClientCommunicationsTabProps } from "./types";

export const ClientCommunicationsTab: React.FC<ClientCommunicationsTabProps> = ({
  issueKey,
  jiraBaseURL,
}) => {
  const { data, loading, error } = useGetLinkedIssueKeysQuery({
    variables: { issueKey },
    fetchPolicy: "network-only",
  });

  const linkedIssues = data?.linkedIssues?.items || [];
  const totalCount = data?.linkedIssues?.totalCount || 0;

  return (
    <Flex flexDirection="column" gap={SPACING.MEDIUM} className={styles.tabContentContainer}>
      <Text variant="h3">Client Communications</Text>

      {loading && !data && (
        <Flex alignItems="center" justifyContent="center" className={styles.loadingContainer}>
          <LoadingIndicator size="medium" data-testid="communications-loading-indicator" />
        </Flex>
      )}

      {error && (
        <Text variant="regular-md" color={Colors.Danger600}>
          Error loading communications: {error.message}
        </Text>
      )}

      {!loading && !error && linkedIssues.length === 0 && (
        <div className={styles.emptyState}>
          <Text variant="regular-md" color={Colors.Neutral600}>
            No linked issues found
          </Text>
        </div>
      )}

      {!loading && !error && linkedIssues.length > 0 && (
        <Flex flexDirection="column" gap={SPACING.MEDIUM}>
          <Text variant="regular-sm" color={Colors.Neutral600}>
            {totalCount} linked {totalCount === 1 ? "issue" : "issues"}
          </Text>
          <div className={styles.linkedIssuesContainer}>
            {linkedIssues.map((linkedIssue) => (
              <LinkedIssueCard
                key={linkedIssue.key}
                linkedIssue={linkedIssue}
                jiraBaseURL={jiraBaseURL}
              />
            ))}
          </div>
        </Flex>
      )}
    </Flex>
  );
};
